import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "best-common-react/lib/styles/bcr.css";
import "./index.css";
import WrapperProvider from "./WrapperProvider";
import { datadogRum } from "@datadog/browser-rum";

const container = document.getElementById("mlb-authentication-app");
const root = createRoot(container!);

if (window.MLBBest.envVariables.ENV !== "local") {
  datadogRum.init({
    applicationId: window.MLBBest.envVariables.DATADOG_APP_ID,
    clientToken: window.MLBBest.envVariables.DATADOG_CLIENT_TOKEN,
    // `site` refers to the Datadog site parameter of your organization
    // see https://docs.datadoghq.com/getting_started/site/
    site: "us5.datadoghq.com",
    service: "best---auth-application",
    env: "prod",
    // Specify a version number to identify the deployed version of your application in Datadog
    // version: '1.0.0',
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    defaultPrivacyLevel: "allow",
  });

  datadogRum.startSessionReplayRecording();
}

root.render(
  <WrapperProvider>
    <App />
  </WrapperProvider>,
);
